export default "__VITE_ASSET__Dj6oa9r6__"